// react and mui stuff
import {useContext, useState} from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ButtermelonContext, UserContext } from '../utils/contexts';
import Toast from '../components/toast';

import CssBaseline from '@mui/joy/CssBaseline';
import { CssVarsProvider } from '@mui/joy/styles';

import buttermelonTheme from '../styles/buttermelon';

// import config from "../data/config.json";

// custom components
import { MetaProps } from '../components/metaprops';
import Layout from '../components/templates/layout';
import Navigation from '../components/templates/navigation';
import Header from '../components/templates/header';

// pages
import Profile from './profile';
import Leaderboard from './leaderboard';
import Sponsor from './sponsor';
import Games from './games';
import NameAudit from './nameaudit';
import PFPAudit from './pfpaudit';
import NoPage from './404';
import Wallpapers from './wallpapers';
import AdminPage from './chatterbox';
import Survey from './survey';
import Reports from './reports/reports'
import Tags from './tags';

// import Tournaments from './tournaments/list';
// import TourneyPage from './tournaments/tourney';
// import CreateTourney from './tournaments/create';

export default function IndexRoutes() {
  const { user } = useContext(UserContext)
  const [navOpen, setNavOpen] = useState(true);
  const [isButtermelon, setButtermelon] = useState(false)
  const loc = useLocation()
  if (!user) return <MetaProps path={loc.pathname}/>

  return (
    <ButtermelonContext.Provider value={{ bm: isButtermelon, setBm: setButtermelon }}>
      <MetaProps path={loc.pathname}/>
      <CssVarsProvider disableTransitionOnChange theme={isButtermelon ? buttermelonTheme : undefined}>
        <CssBaseline />
        <Layout.Root
          sx={[{
            gridTemplateColumns: {
              xs: '1fr',
              sm: navOpen ? 'minmax(64px, 200px) minmax(450px, 1fr)' : "1fr",
              md: navOpen ? 'minmax(160px, 300px) minmax(600px, 1fr)' : "1fr",
            }
          }]}
        >
          {/** Header */}
          <Layout.Header>
            <Header setNavOpen={setNavOpen} navOpen={navOpen}/>
          </Layout.Header>

          {/** Navigation Bar */}
          { navOpen &&
            <Layout.SideNav>
              <Navigation/>
            </Layout.SideNav>
          }

          {/** Routes */}
          <Layout.Main sx={{ overflowY: "auto" }}>
            <Toast/>
            <Routes>
              <Route path="/" element={<Navigate to={`/profile/${user.id}`}/>}/>
              <Route path="/profile" element={<Navigate to={`/profile/${user.id}`}/>}/>
              <Route path='/profile/:id?' element={<Profile/>}/>
              <Route path='/leaderboard' element={<Leaderboard/>}/>
              <Route path='/sponsor' element={<Sponsor/>}/>
              <Route path='/store' element={<Games/>}/>
              <Route path='/survey' element={<Survey/>}/>

              {
                /**
                 * {config.tournamentReady && <Route path='/tournaments/*' element={
                 * <Routes>
                 *   <Route path='/' element={<Tournaments/>}/>
                 *   <Route path='/:id' element={<TourneyPage/>}/>
                 *   <Route path='/create' element={<CreateTourney/>}/>
                 *   {<Route path='/:id/edit' element={<EditTourney/>}/>}
                 * </Routes>
                 * }/>}
                 */
              }
              
              { user.perms.isMod &&  <Route path = '/mod/*' element={
                <Routes>
                  <Route path="/" element={<Navigate to="/mod/names"/>}/>
                  <Route path="/names" element={<NameAudit/>}/>
                  <Route path="/pfps" element={<PFPAudit/>}/>
                </Routes>
              }/>}
              { user.perms.isMgr &&  <Route path = '/reports' element={<Reports/>}/> }
              { user.perms.isMgr &&  <Route path = '/tags' element={<Tags/>}/> }
              { /** user.perms.isMgr &&  <Route path = '/manager' element={<Profile/>}/> */ }
              { /** user.perms.isMgmt &&  <Route path = '/management/*' element={<Profile/>}/> */ }
              { user.perms.isOwner && <Route path="/chatterbox" element={<AdminPage/>}/> }
              <Route path="/wallpapers" element={<Wallpapers/>}/>
              <Route path='/*' element={<NoPage/>}/>
            </Routes>
          </Layout.Main>
        </Layout.Root>
      </CssVarsProvider>
    </ButtermelonContext.Provider>
  )
}